import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const AdminDashboard = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');
  const [showUserModal, setShowUserModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleSaveUser = () => {
    // Simulate saving user
    if (selectedUser?._id) {
      // Update existing user
      console.log('Updating user:', selectedUser);
      alert('User updated successfully!');
    } else {
      // Add new user
      const newUser = {
        _id: Date.now().toString(),
        ...selectedUser,
        totalOrders: 0,
        totalSpent: 0,
        createdAt: new Date().toISOString()
      };
      console.log('Adding new user:', newUser);
      alert('New user added successfully!');
    }
    
    setShowUserModal(false);
    setSelectedUser(null);
  };

  const handleSaveProduct = () => {
    // Simulate saving product
    if (selectedProduct?._id) {
      // Update existing product
      console.log('Updating product:', selectedProduct);
      alert('Product updated successfully!');
    } else {
      // Add new product
      const newProduct = {
        _id: Date.now().toString(),
        ...selectedProduct,
        orders: 0,
        createdAt: new Date().toISOString()
      };
      console.log('Adding new product:', newProduct);
      alert('New product added successfully!');
    }
    
    setShowProductModal(false);
    setSelectedProduct(null);
  };

  const handleSaveOrder = () => {
    // Save order logic here
    setShowOrderModal(false);
  };

  const handleExportOrders = () => {
    // Simulate order export
    const orderData = stats.recentOrders || [];
    const csvContent = "Order Number,Customer,Platform,Price,Status,Date\n" +
      orderData.map(order => `${order.orderNumber},${order.user?.firstName} ${order.user?.lastName},${order.platform},${order.price},${order.status},${new Date(order.createdAt).toLocaleDateString()}`).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'orders_export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    
    alert('Orders exported successfully!');
  };

  const handleFilterUsers = () => {
    // Simulate filter functionality
    alert('Filter functionality would open here - you can filter by status, date, orders, etc.');
  };

  const handleFilterProducts = () => {
    // Simulate filter functionality
    alert('Filter functionality would open here - you can filter by platform, price, status, etc.');
  };

  const handleFilterOrders = () => {
    // Simulate filter functionality
    alert('Filter functionality would open here - you can filter by status, date, customer, platform, etc.');
  };

  // Use mock data directly for better performance
  const mockStats = {
    totalUsers: 1250,
    totalOrders: 3420,
    totalRevenue: 45680,
    recentOrders: [
      { _id: 1, orderNumber: "ORD-101", user: { firstName: "John", lastName: "Doe" }, price: 20, platform: "instagram", status: "completed" },
      { _id: 2, orderNumber: "ORD-102", user: { firstName: "Jane", lastName: "Smith" }, price: 15, platform: "facebook", status: "processing" },
      { _id: 3, orderNumber: "ORD-103", user: { firstName: "Mike", lastName: "Johnson" }, price: 25, platform: "twitter", status: "pending" }
    ],
    ordersByStatus: [
      { _id: "completed", count: 2100 },
      { _id: "processing", count: 450 },
      { _id: "pending", count: 320 },
      { _id: "cancelled", count: 50 }
    ],
    packagesByPlatform: [
      { _id: "instagram", name: "Instagram", count: 1200, revenue: 15000 },
      { _id: "facebook", name: "Facebook", count: 800, revenue: 10000 },
      { _id: "tiktok", name: "TikTok", count: 600, revenue: 8000 },
      { _id: "twitter", name: "Twitter", count: 400, revenue: 5000 },
      { _id: "youtube", name: "YouTube", count: 300, revenue: 4000 }
    ]
  };

  const stats = mockStats;
  const isLoading = false;

  const mockUsers = [
    { _id: 1, firstName: "John", lastName: "Doe", email: "john@example.com", status: "active", totalOrders: 12, totalSpent: 240 },
    { _id: 2, firstName: "Jane", lastName: "Smith", email: "jane@example.com", status: "active", totalOrders: 8, totalSpent: 160 },
    { _id: 3, firstName: "Mike", lastName: "Johnson", email: "mike@example.com", status: "inactive", totalOrders: 3, totalSpent: 45 }
  ];

  const mockProducts = [
    { _id: 1, name: "Instagram Standard", platform: "instagram", followers: 1000, price: 20, status: "active", orders: 450 },
    { _id: 2, name: "Facebook Premium", platform: "facebook", followers: 2000, price: 35, status: "active", orders: 320 },
    { _id: 3, name: "Twitter Pro", platform: "twitter", followers: 1500, price: 25, status: "inactive", orders: 280 }
  ];

  const handleUserAction = (action, user) => {
    setSelectedUser(user);
    if (action === 'edit' || action === 'delete') {
      setShowUserModal(true);
    }
  };

  const handleProductAction = (action, product) => {
    setSelectedProduct(product);
    if (action === 'edit' || action === 'delete') {
      setShowProductModal(true);
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'active': return 'bg-green-100 text-green-600';
      case 'inactive': return 'bg-gray-100 text-gray-600';
      case 'pending': return 'bg-yellow-100 text-yellow-600';
      case 'processing': return 'bg-blue-100 text-blue-600';
      case 'completed': return 'bg-green-100 text-green-600';
      case 'cancelled': return 'bg-red-100 text-red-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-brinjal-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-premium-purple-50 to-premium-purple-100 py-8 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white">
            Admin Dashboard
          </h1>
          <p className="text-white">
            Manage your Followers Hub platform
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="border-b border-premium-purple-800 mb-8">
          <nav className="-mb-px flex space-x-8">
            {['overview', 'users', 'products', 'orders'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`py-2 px-1 border-b-2 font-medium text-sm capitalize transition-all duration-300 ${
                  activeTab === tab
                    ? 'border-light-purple-300 text-light-purple-300 premium-glow'
                    : 'border-transparent text-white hover:text-light-purple-200 hover:border-premium-purple-600'
                }`}
              >
                {tab}
              </button>
            ))}
          </nav>
        </div>

        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="space-y-8">
            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="card premium-glow">
                <div className="flex items-center">
                  <div className="p-3 bg-blue-900 bg-opacity-50 rounded-lg border border-blue-700">
                    <svg className="h-8 w-8 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-2H8a3 3 0 00-5.356 2H4m0 0V6a3 3 0 013-3h7.356a3 3 0 015.356 2H20a3 3 0 013 3v14a3 3 0 01-3 3h-7.356a3 3 0 01-5.356-2H4a3 3 0 01-3-3V6a3 3 0 013-3h7.356a3 3 0 015.356 2H20z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-white">Total Users</p>
                    <p className="text-2xl font-bold text-white">{stats.totalUsers?.toLocaleString() || 0}</p>
                  </div>
                </div>
              </div>

              <div className="card premium-glow">
                <div className="flex items-center">
                  <div className="p-3 bg-green-900 bg-opacity-50 rounded-lg border border-green-700">
                    <svg className="h-8 w-8 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2v2a2 2 0 012 2h2a2 2 0 002-2V7a2 2 0 00-2-2H9z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-white">Total Orders</p>
                    <p className="text-2xl font-bold text-white">{stats.totalOrders?.toLocaleString() || 0}</p>
                  </div>
                </div>
              </div>

              <div className="card premium-glow">
                <div className="flex items-center">
                  <div className="p-3 bg-yellow-900 bg-opacity-50 rounded-lg border border-yellow-700">
                    <svg className="h-8 w-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8m0 1V7m0 1V8" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-white">Total Revenue</p>
                    <p className="text-2xl font-bold text-white">${stats.totalRevenue?.toLocaleString() || 0}</p>
                  </div>
                </div>
              </div>

              <div className="card premium-glow">
                <div className="flex items-center">
                  <div className="p-3 bg-purple-900 bg-opacity-50 rounded-lg border border-purple-700">
                    <svg className="h-8 w-8 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7m0 0v-7m0 7l4-4m4 4v7m0 0v-7m0 7l-4-4" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium text-white">Active Now</p>
                    <p className="text-2xl font-bold text-white">Online</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Orders & Status */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="card premium-glow">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-light-purple-200 mb-4">Recent Orders</h2>
                  <div className="flex space-x-3">
                    <button onClick={handleExportOrders} className="btn-secondary text-white">
                      Export Orders
                    </button>
                    <button onClick={() => setShowOrderModal(true)} className="btn-primary text-white">
                      Add Order
                    </button>
                  </div>
                </div>
                <div className="space-y-3">
                  {stats.recentOrders?.slice(0, 5).map((order, index) => (
                    <div key={order._id} className="flex items-center justify-between p-3 bg-premium-purple-200 rounded-lg hover:bg-premium-purple-300 transition-all duration-300 border border-premium-purple-600">
                      <div>
                        <p className="text-sm font-medium text-light-purple-200">#{order.orderNumber}</p>
                        <p className="text-xs text-light-purple-400">{order.user?.firstName} {order.user?.lastName}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-sm font-medium text-light-purple-200">${order.price}</p>
                        <p className="text-xs text-light-purple-400">{order.platform}</p>
                      </div>
                    </div>
                  ))}
                  {(!stats.recentOrders || stats.recentOrders.length === 0) && (
                    <p className="text-light-purple-400 text-center py-4">No recent orders</p>
                  )}
                </div>
              </div>

              <div className="card premium-glow">
                <h2 className="text-xl font-bold text-light-purple-200 mb-4">Orders by Status</h2>
                <div className="space-y-3">
                  {stats.ordersByStatus?.map((status, index) => (
                    <div key={status._id} className="flex items-center justify-between p-3 bg-premium-purple-200 rounded-lg hover:bg-premium-purple-300 transition-all duration-300 border border-premium-purple-600">
                      <div className="flex items-center">
                        <div className={`w-3 h-3 rounded-full mr-3 ${
                          status._id === 'completed' ? 'bg-green-400' :
                          status._id === 'processing' ? 'bg-blue-400' :
                          status._id === 'pending' ? 'bg-yellow-400' : 'bg-red-400'
                        }`}></div>
                        <span className="text-sm font-medium text-light-purple-200 capitalize">{status._id}</span>
                      </div>
                      <span className="text-sm font-bold text-light-purple-200">{status.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Top Packages */}
            <div className="card premium-glow">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-light-purple-200 mb-4">Top Selling Packages</h2>
                <button onClick={() => setShowProductModal(true)} className="btn-primary text-white">
                  Add New Product
                </button>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-premium-purple-600">
                  <thead className="bg-premium-purple-300">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-light-purple-300 uppercase tracking-wider">
                        Package
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-light-purple-300 uppercase tracking-wider">
                        Orders
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-light-purple-300 uppercase tracking-wider">
                        Revenue
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-premium-purple-100 divide-y divide-premium-purple-600">
                    {stats.topPackages?.map((pkg, index) => (
                      <tr key={pkg._id} className="hover:bg-premium-purple-200 transition-all duration-300">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-light-purple-200">
                          {pkg.package?.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-light-purple-300">
                          {pkg.count}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-light-purple-300">
                          ${pkg.revenue?.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Users Tab */}
        {activeTab === 'users' && (
          <div className="bg-white rounded-2xl shadow p-6 border border-brinjal-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">User Management</h2>
              <div className="flex space-x-3">
                <button onClick={handleFilterUsers} className="btn-secondary">
                  Filter Users
                </button>
                <button onClick={() => {
                  setSelectedUser({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    role: 'user',
                    status: 'active'
                  });
                  setShowUserModal(true);
                }} className="btn-primary">
                  Add New User
                </button>
              </div>
            </div>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      User
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Orders
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total Spent
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {mockUsers.map((user) => (
                    <tr key={user._id} className="hover:bg-brinjal-50 transition">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {user.firstName} {user.lastName}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {user.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(user.status)}`}>
                          {user.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {user.totalOrders}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        ${user.totalSpent}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button 
                          onClick={() => handleUserAction('edit', user)}
                          className="text-brinjal-600 hover:text-brinjal-900 mr-3"
                        >
                          Edit
                        </button>
                        <button 
                          onClick={() => handleUserAction('delete', user)}
                          className="text-red-600 hover:text-red-900"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Products Tab */}
        {activeTab === 'products' && (
          <div className="bg-white rounded-2xl shadow p-6 border border-brinjal-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Product Management</h2>
              <div className="flex space-x-3">
                <button onClick={handleFilterProducts} className="btn-secondary">
                  Filter Products
                </button>
                <button onClick={() => {
                  setSelectedProduct({
                    name: '',
                    platform: 'instagram',
                    followers: 1000,
                    price: 10,
                    status: 'active',
                    description: ''
                  });
                  setShowProductModal(true);
                }} className="btn-primary">
                  Add New Product
                </button>
              </div>
            </div>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Product Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Platform
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Followers
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Orders
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {mockProducts.map((product) => (
                    <tr key={product._id} className="hover:bg-brinjal-50 transition">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {product.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                        {product.platform}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {product.followers}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        ${product.price}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(product.status)}`}>
                          {product.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {product.orders}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button 
                          onClick={() => handleProductAction('edit', product)}
                          className="text-brinjal-600 hover:text-brinjal-900 mr-3"
                        >
                          Edit
                        </button>
                        <button 
                          onClick={() => handleProductAction('delete', product)}
                          className="text-red-600 hover:text-red-900"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Orders Tab */}
        {activeTab === 'orders' && (
          <div className="bg-white rounded-2xl shadow p-6 border border-brinjal-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Order Management</h2>
              <div className="flex gap-2">
                <button onClick={handleFilterOrders} className="btn-secondary">
                  Filter Orders
                </button>
                <button onClick={handleExportOrders} className="btn-secondary">
                  Export Orders
                </button>
                <button onClick={() => setShowOrderModal(true)} className="btn-primary">
                  Add Order
                </button>
              </div>
            </div>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Order #
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Customer
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Platform
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Followers
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Payment
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {stats.recentOrders?.map((order) => (
                    <tr key={order._id} className="hover:bg-brinjal-50 transition">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {order.orderNumber}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {order.user?.firstName} {order.user?.lastName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                        {order.platform}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        1000
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        ${order.price}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        JazzCash
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(order.status)}`}>
                          {order.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        2024-01-15
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button className="text-brinjal-600 hover:text-brinjal-900 mr-3">
                          View
                        </button>
                        <button className="text-blue-600 hover:text-blue-900 mr-3">
                          Edit
                        </button>
                        <button className="text-red-600 hover:text-red-900">
                          Cancel
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* User Management Modal */}
        {showUserModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
              <h3 className="text-xl font-semibold mb-4">
                {selectedUser ? 'Manage User' : 'Add New User'}
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">First Name</label>
                  <input 
                    type="text" 
                    name="firstName"
                    value={selectedUser?.firstName || ''} 
                    onChange={(e) => setSelectedUser({...selectedUser, firstName: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter first name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Last Name</label>
                  <input 
                    type="text" 
                    name="lastName"
                    value={selectedUser?.lastName || ''} 
                    onChange={(e) => setSelectedUser({...selectedUser, lastName: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter last name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email</label>
                  <input 
                    type="email" 
                    name="email"
                    value={selectedUser?.email || ''} 
                    onChange={(e) => setSelectedUser({...selectedUser, email: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter email address"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Phone</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={selectedUser?.phone || ''} 
                    onChange={(e) => setSelectedUser({...selectedUser, phone: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter phone number"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Role</label>
                  <select 
                    className="input-field mt-1"
                    value={selectedUser?.role || 'user'}
                    onChange={(e) => setSelectedUser({...selectedUser, role: e.target.value})}
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Status</label>
                  <select 
                    className="input-field mt-1"
                    value={selectedUser?.status || 'active'}
                    onChange={(e) => setSelectedUser({...selectedUser, status: e.target.value})}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="flex gap-4 mt-6">
                <button onClick={() => {
                  setShowUserModal(false);
                  setSelectedUser(null);
                }} className="flex-1 btn-secondary">
                  Cancel
                </button>
                <button onClick={handleSaveUser} className="flex-1 btn-primary">
                  {selectedUser?._id ? 'Update User' : 'Add New User'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Product Management Modal */}
        {showProductModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
              <h3 className="text-xl font-semibold mb-4">
                {selectedProduct?._id ? 'Manage Product' : 'Add New Product'}
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Product Name</label>
                  <input 
                    type="text" 
                    name="name"
                    value={selectedProduct?.name || ''} 
                    onChange={(e) => setSelectedProduct({...selectedProduct, name: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter product name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Platform</label>
                  <select 
                    className="input-field mt-1"
                    value={selectedProduct?.platform || 'instagram'}
                    onChange={(e) => setSelectedProduct({...selectedProduct, platform: e.target.value})}
                  >
                    <option value="instagram">Instagram</option>
                    <option value="facebook">Facebook</option>
                    <option value="tiktok">TikTok</option>
                    <option value="twitter">Twitter</option>
                    <option value="youtube">YouTube</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Followers Count</label>
                  <input 
                    type="number" 
                    name="followers"
                    value={selectedProduct?.followers || ''} 
                    onChange={(e) => setSelectedProduct({...selectedProduct, followers: parseInt(e.target.value)})}
                    className="input-field mt-1" 
                    placeholder="Enter followers count"
                    min="100"
                    step="100"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Price ($)</label>
                  <input 
                    type="number" 
                    name="price"
                    value={selectedProduct?.price || ''} 
                    onChange={(e) => setSelectedProduct({...selectedProduct, price: parseFloat(e.target.value)})}
                    className="input-field mt-1" 
                    placeholder="Enter price"
                    min="1"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Status</label>
                  <select 
                    className="input-field mt-1"
                    value={selectedProduct?.status || 'active'}
                    onChange={(e) => setSelectedProduct({...selectedProduct, status: e.target.value})}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="out-of-stock">Out of Stock</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Description</label>
                  <textarea 
                    name="description"
                    value={selectedProduct?.description || ''} 
                    onChange={(e) => setSelectedProduct({...selectedProduct, description: e.target.value})}
                    className="input-field mt-1" 
                    placeholder="Enter product description"
                    rows="3"
                  />
                </div>
              </div>
              <div className="flex gap-4 mt-6">
                <button onClick={() => {
                  setShowProductModal(false);
                  setSelectedProduct(null);
                }} className="flex-1 btn-secondary">
                  Cancel
                </button>
                <button onClick={handleSaveProduct} className="flex-1 btn-primary">
                  {selectedProduct?._id ? 'Update Product' : 'Add New Product'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Order Management Modal */}
        {showOrderModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
              <h3 className="text-xl font-semibold mb-4">Add New Order</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Order Number</label>
                  <input type="text" className="input-field mt-1" placeholder="Enter order number" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Customer Name</label>
                  <input type="text" className="input-field mt-1" placeholder="Enter customer name" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Platform</label>
                  <select className="input-field mt-1">
                    <option value="">Select Platform</option>
                    <option value="facebook">Facebook</option>
                    <option value="instagram">Instagram</option>
                    <option value="tiktok">TikTok</option>
                    <option value="twitter">Twitter</option>
                    <option value="youtube">YouTube</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Price</label>
                  <input type="number" className="input-field mt-1" placeholder="Enter price" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Status</label>
                  <select className="input-field mt-1">
                    <option value="pending">Pending</option>
                    <option value="processing">Processing</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </div>
              <div className="flex gap-4 mt-6">
                <button onClick={() => setShowOrderModal(false)} className="flex-1 btn-secondary">
                  Cancel
                </button>
                <button onClick={handleSaveOrder} className="flex-1 btn-primary">
                  Add Order
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default AdminDashboard;
